<template>
  <div class="flex justify-center items-center">

    <div class="flex h-24 w-24 relative">
      <div class="rounded-md w-full h-full absolute top-0 left-0 overflow-hidden " :class="{'bg-white': !profilePicUrl, 'shadow-md': !profilePicUrl}">
        <div v-if="profilePicUrl" class="bg-cover relative w-full h-full" :style="{backgroundImage: `url('${profilePicUrl}')`}" />
        <div v-else v-html="icon('profile')" class="w-full h-full flex justify-center items-center"></div>
      </div>
      <label class="w-full h-full absolute top-0 left-0 flex justify-end items-end">
        <div>
          <svg v-if="profilePicUrl" xmlns="http://www.w3.org/2000/svg" width="37" height="37" class="mr-1 mb-1"><path fill="#e3064a" d="M0 18.5a18.5 18.5 0 1137 0 18.5 18.5 0 01-37 0z"/><path fill="#fff" d="M26.5 14.5v9.8A1.6 1.6 0 0125 26H10.8A1.6 1.6 0 019 24.3v-9.8a1.6 1.6 0 011.7-1.6h3l.4-1a1.6 1.6 0 011.5-1H20a1.6 1.6 0 011.5 1l.4 1h3a1.6 1.6 0 011.7 1.6zm-4.6 5a4 4 0 10-4 4 4 4 0 004-4zm-1 0a3 3 0 11-3-3 3 3 0 013 3z"/></svg>
          <div v-html="icon('plus')" v-else></div>
        </div>
        <input type="file" class="hidden" @input="uploadNew" accept="image/*">
      </label>
    </div>
  </div>

</template>
<script>
import { getIconHtml, icons } from '@/services/icons'

export default {
  computed: {
    profilePicUrl() {
      return this.$store.getters.userPic
    }
  },
  methods: {
    icon(name) {
      return getIconHtml(icons[name])
    },
    async uploadNew(e) {
      if(e.target.files.length) {
        const f = e.target.files[0]
        await this.$store.dispatch('uploadUserPic', f)
      }
    }
  }
}
</script>

<style>

</style>